import { Badge } from "./Badge";
import { STATUS_META } from "../../lib/leads";

/* Status pill — looks up STATUS_META by status code and renders a Badge
   with the appropriate color class. Falls back to the "new" palette for
   unknown codes (e.g. legacy values after custom statuses are removed). */
export function StatusBadge({ status }) {
  const m = STATUS_META[status] || STATUS_META.new;
  return <Badge cls={m.cls}>{m.label}</Badge>;
}
